import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { PopupTooltip, Button, Icon } from '@adc/ui-core'
import styles from '../../../tutorialTooltip/components/styles.scss'
const cx = classnames.bind(styles)

const NudgeTooltip = ({
  children,
  showTooltip,
  handleClose,
  handleSuccess,
  elmId,
  header,
  content,
  fade,
  style = 'blue',
}) => {
  const tooltipHeader = () => (
    <div className={cx('tooltip-header-root', 'u-mb-2')}>
      <div className={cx('tooltip-header')}>{header}</div>
      <div className={cx('tooltip-close-root')}>
        <Icon
          name='times'
          size='large'
          color='white'
          iconStyle='light'
          data-elm-id={`${elmId}_tooltip_close_icon`}
          className={cx('tooltip-close-icon')}
          onClick={handleClose}
        />
      </div>
    </div>
  )

  const tooltipContent = () => (
    <>
      <div className={cx('tooltip-content')}>{content}</div>
      <div className='u-mt-4'>
        <Button
          size='small'
          role='primary'
          className={cx('tooltip-next-button')}
          elmId={`${elmId}_tooltip_next_button`}
          onClick={handleSuccess}
        >
          Let's Go
        </Button>
      </div>
    </>
  )

  return showTooltip ? (
    <PopupTooltip
      open
      pinned
      trigger={
        <div
          data-elm-id={`${elmId}_tooltip_container`}
          className={cx('flexbox')}
        >
          {fade && <div className={cx('dimmer')} onClick={handleClose} />}
          <div className={cx('show', 'flexbox')}>{children}</div>
        </div>
      }
      header={tooltipHeader}
      content={tooltipContent}
      data-elm-id={`${elmId}_tooltip`}
      position='bottom right'
      className={cx('tooltip-root', 'nudge', `${style}-tooltip`)}
      wide
    />
  ) : (
    <div className={cx('flexbox')}>{children}</div>
  )
}

NudgeTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  showTooltip: PropTypes.bool,
  elmId: PropTypes.string,
  header: PropTypes.node,
  fade: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  handleSuccess: PropTypes.func.isRequired,
  style: PropTypes.string,
}

export default NudgeTooltip
